module.exports = __webpack_public_path__ + "static/media/liquid-cheese.4567a8fb.svg";